/**
 * Waar je een probleem uit 'Niet te berekenen' oplost: een korte handeling en
 * de pagina erbij (zonder `/<client>/` ervoor). De deelnemerspagina opent het
 * juiste tabblad via `?tab=` en scrolt naar het blok in de `#hash`
 * (`useScrollToHash`) — dat leest `PersonaBuilder.jsx`, en de test zet die
 * afspraak vast.
 *
 * AI-CONTEXT: See docs/pitfalls.md#routing-url-built-here-read-by-position-there
 *
 * @param {string} reason - Reden uit `computeBilling` (`SkipReason`)
 * @param {string} personaId - `ID` van de deelnemer
 * @returns {{label: string, path: string}|null} `null` als er voor de gebruiker niets op te lossen valt
 */
const skipFix = (reason, personaId) => {
    const persona = (tab) => `personabuilder/${personaId}?tab=${tab}`
    switch (reason) {
        case 'noRoute': return { label: 'Traject kiezen', path: `${persona('data')}#persona-traject` }
        case 'noTariff': return { label: 'Tarief toevoegen', path: `${persona('data')}#persona-tarief` }
        case 'unitNotBillable': return { label: 'Eenheid van het traject aanpassen', path: 'settings/6#settings-trajecten' }
        case 'duplicateReport': return { label: 'Dubbele registratie verwijderen', path: persona('presence') }
        case 'noHours': return { label: 'Tijden aanvullen', path: persona('presence') }
        case 'unknownPersona': return { label: 'Deelnemer terugzetten', path: 'prullenbak' }
        default: return null
    }
}

export default skipFix
